import { IDatiqDatepicker } from './datiq-datepicker.interface';
import {
    emptyDatiqInput,
    DatiqInputTypes,
} from '@dat/datiq-components-pkg/utils';
import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';

export const emptyDatiqDatepicker: IDatiqDatepicker = {
    ...emptyDatiqInput,
    id: DATIQ_DEFAULT_ID(),
    name: DATIQ_DEFAULT_ID(),
    type: DatiqInputTypes.Date,
    label: 'Select Date',
};
